import React from 'react'
import { Link } from 'react-router-dom'
import auth from '../firebase'

import { Layout } from 'antd'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import '../css/form.css'

const { Content } = Layout

class LoginForm extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            password: '',
            message: '',
            currentUser: null,
            uid: null
        }

    }

    componentDidMount() {
        auth.onAuthStateChanged(user => {
            if (user) {
                this.setState({
                    currentUser: user
                })
            }
        })
    }

    onChange = e => {
        const { name, value } = e.target

        this.setState({
            [name]: value
        })
    }

    onSubmit = e => {
        e.preventDefault()

        const { email, password } = this.state
        auth
            .signInWithEmailAndPassword(email, password)
            .then(response => {
                this.setState({
                    currentUser: response.user,
                    uid: response.user.uid
                })
            })
            .catch(error => {
                this.setState({
                    message: error.message
                })
            })
    }

    logout = e => {
        e.preventDefault()
        auth.signOut().then(response => {
            this.setState({
                currentUser: null,
                uid: null
            })
        })
        localStorage.clear();
    }

    render() {
        const { message, currentUser } = this.state

        if (currentUser) {
            localStorage.setItem('uid_user', currentUser.uid);
            return (
                <Layout>
                    <Navbar selected="user:2" />
                    <Content style={{ padding: '0 20px' }}>
                        <div style={{ background: '#fff', padding: 50, minHeight: 'calc(100vh - 64px - 69px)' }}>

                            <p>Hello {currentUser.email}</p>
                            <Link to="/Labels" ><button style={{ color: '#535353' }}> Go To Labels </button></Link> &nbsp;
                            <button onClick={this.logout}>Logout</button>

                        </div>
                    </Content>
                </Layout>
            )

        }

        return (

            <Layout>
                <Navbar selected="user:2" />
                <Content style={{ padding: '0 20px' }}>
                    <div style={{ background: '#fff', padding: 50, minHeight: 'calc(100vh - 64px - 69px)' }}>
                        <h2>Login</h2>
                        <form onSubmit={this.onSubmit}>
                            <div className="field">
                                <label className="label">Email</label>
                                <div className="control">
                                    <input
                                        className="input"
                                        type="email"
                                        name="email"
                                        onChange={this.onChange}
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label className="label">Password</label>
                                <div className="control">
                                    <input
                                        className="input"
                                        type="password"
                                        name="password"
                                        onChange={this.onChange}
                                    />
                                </div>
                            </div>

                            {message ? <p className="help is-danger">{message}</p> : null}

                            <div className="field is-grouped">
                                <div className="control">
                                    <br />
                                    <button className="button is-link">Submit</button>
                                </div>
                            </div>
                        </form>

                    </div>
                </Content>
                <Footer />
            </Layout>
        )
    }
}

export default LoginForm



// WEBPACK FOOTER //
// ./src/pages/Login.js